import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_DOC',
  title: 'Comment déposer ou mettre à jour un document ? ',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez sur le bouton « Déposer » à droite du document'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DOC/FR_DEPOT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Ensuite, déposer ou glisser votre document au centre de la zone'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DOC/FR_DEPOT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Renseignez les champs puis validez'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DOC/FR_DEPOT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Votre document passe au statut « en cours de vérification ». Chaque document est authentifié puis validé par nos équipes.'
  }]
};
